module.exports = {
  i18n: {
    //首页
    MyJournal: "MyJournal",
    HumanBrainForum: "Human Brain Forum",
    Directions: "Directions",
    Viewmore: "Viewmore",
    Viewmore: "Viewmore",
    China: "China",
    USA: "USA",
    USEuro: "USEuro",
    Directions: "Directions",
    NewsEvents: "NewsEvents",
    Viewmore: "Viewmore",
    //新闻资讯
    Hotspots: "Hotspots",
    Progress: "Progress",
    //脑计划
    BrainPlan: "BrainPlan",
    //临床指南
    Pleaseentercontent: "Pleaseentercontent",
    //学术会议
    PastBrainBankAlliancemeetings: "PastBrainBankAlliancemeetings",
    Periodicals: "Periodicals",
    Readall: "Readall",
    Conferenceprogramme: "Conferenceprogramme",
    Organization: "Organization",
    ConferenceKeynote: "ConferenceKeynote",
    GuestIntroduction: "GuestIntroduction",
    //期刊
    regardingPeriodicals: "regardingPeriodicals",
    Viewtheeditorialteam: "Viewtheeditorialteam",
    //查看详情
    Seedetails: "Seedetails",
    //底部
    LicensingandTechnicalSupport: "LicensingandTechnicalSupport",
    Editquery: "Editquery",
    Netherlands: "Netherlands",
    //了解更多
    Learnmore: "Learnmore",
    //资讯推荐
    Informationrecommendation: "Informationrecommendation",
    //附件
    Attachments: "Attachments",
    //名誉主编
    HonoraryEditorinChief: "HonoraryEditorinChief",
    //主编辑
    ChiefEditor: "ChiefEditor",
    //名誉主编
    ConsultantEditor: "ConsultantEditor",
    //基础研究方向副主编
    AssociateEditorofBasicResearch: "AssociateEditorofBasicResearch",
    //临床研究方向副主编
    AssociateEditorofClinicalResearch: "AssociateEditorofClinicalResearch",
    //助理编辑
    AssistantEditor: "AssistantEditor",
    //详情
    Details: "Details",
    //国外主旨演讲科学家
    ForeignKeynoteSpeechScientists: "ForeignKeynoteSpeechScientists",
    //国内主旨演讲科学家
    NationalKeynoteSpeechScientists: "NationalKeynoteSpeechScientists",
    //国际
    Internationalguestspeakers: "Internationalguestspeakers",
    //国际
    Domesticspeakers: "Domesticspeakers",
    //发布时间
    Releasetime: "Releasetime",
    //阅读全文
    Readthefullarticle: "Readthefullarticle",
    //主编
    EditorChief: "EditorChief",
    //点击此处了解更多期刊信息
    Clickhereformorejournalinformation: "Clickhereformorejournalinformation",
    //介绍
    Introduction: "Introduction",
    // 简历
    Resume: "Resume",
    // 资源情况
    Resource: "Resource Availability",
    // 往期人脑论坛会
    pastHumanBrainForum: "Past Human Brain Forums",
    // 正在进行人脑论坛会
    upcomingHumanBrainForum: "The Human Brain Forum is currently underway",
    // 国家发育和功能人脑组织资源库
    HumanBrainForumText:
      "National Resource Bank of Developing and Functional Human Brain Tissues",
  },
};
